import { render } from "./Rimborsi.vue?vue&type=template&id=54d15512&scoped=true&ts=true"
import script from "./Rimborsi.vue?vue&type=script&lang=ts"
export * from "./Rimborsi.vue?vue&type=script&lang=ts"

import "./Rimborsi.vue?vue&type=style&index=0&id=54d15512&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d15512"]])

export default __exports__